import { StudentService } from 'src/app/_services/student.service';
import { AdminService } from '../../../_services/admin.service';

import { ActivatedRoute, Router } from '@angular/router';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResultData } from 'src/app/_models/ResultData';
import { CountryService } from 'src/app/_services/country.service';
import { LevelService } from 'src/app/_services/level.service';
import { SubjectService } from 'src/app/_services/subject.service';

@Component({
  selector: 'app-subscription-grouping-edit',
  templateUrl: './subscription-grouping-edit.component.html',
  styleUrls: ['./subscription-grouping-edit.component.css']
})
export class SubscriptionGroupingEditComponent implements OnInit {

  breakSavePath="/batch/group/show"
  myForm:FormGroup
  countries=[]
  curriculums=[]
  levels=[]
  subjects=[]
  subjectId=0
  loading=false
  subscriptionGroup:any =undefined
  subscriptionGrouping:any =undefined
  server_subscription_group_id=0
  server_subscription_grouping_id=0
  isSaving=false
  errorSaving=false
  constructor(
    private adminService:AdminService,
    private router:Router,
    private countryService:CountryService,
    private levelService:LevelService,
    private subjectService:SubjectService,
    private activatedRoute:ActivatedRoute,
    private studentService:StudentService) { }

  ngOnInit(): void {
    this.loadSubscriptionGroup()

  }


  get f() {
    return this.myForm.controls
  }
  initMainFormUpdate(updateData:any){
    this.myForm=new FormGroup({
      name: new FormControl(updateData['name'], [Validators.required]),
      description: new FormControl(updateData['description'], [Validators.required]),
      country: new FormControl("", [Validators.required]),
      level: new FormControl(updateData['level'], [Validators.required]),
      subjectId: new FormControl(updateData['subjectId'], [Validators.required]),
      subjectIdDecoy: new FormControl(updateData['subjectId'], [Validators.required])
    });
  }
  initMainFormFresh(){
    this.myForm=new FormGroup({
      name: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
      country: new FormControl("", [Validators.required]),
      curriculum: new FormControl("", [Validators.required]),
      level: new FormControl("", [Validators.required]),
      subjectId: new FormControl("", [Validators.required]),
      subjectIdDecoy: new FormControl("", [Validators.required])
    });
  }

loadSubscriptionGroup(){
  this.loading=true
  this.countryService.getCountriesIdAndName().subscribe(
    x => {this.countries = x}
  )
  this.levelService.getCurriculums().subscribe(
    {next:(data:ResultData)=>{this.curriculums= data.rs.data },error:(err)=>{console.log("error getting curriculums",err)}
  })

  this.activatedRoute.params.subscribe(
    paramsIn=>{
      this.server_subscription_group_id=paramsIn['server_subscription_group_id']
      this.server_subscription_grouping_id=paramsIn['server_subscription_grouping_id']
      if(this.server_subscription_group_id!=0){
        this.adminService.getSubscriptionGroup(this.server_subscription_group_id).subscribe(
          abilityIn=>{
            this.subscriptionGroup = abilityIn

            if(this.server_subscription_grouping_id==0){
              this.initMainFormFresh()
              this.loading=false
            }else{
              this.loadSubscriptionGrouping()
              this.loading=false
            }
          }
        )
      }else{

        this.loading=false
      }
    }
  )
}

loadSubscriptionGrouping(){
  this.adminService.getSubscriptionGrouping(this.server_subscription_grouping_id).subscribe(
    sGs=>{
         this.subscriptionGrouping=sGs
         this.initMainFormUpdate(this.subscriptionGrouping)
    }
  )
}
on_submit(){
  this.isSaving=true
  let dd=this.formatData(this.myForm.value.name,this.myForm.value.description,this.myForm.value.country,this.myForm.value.curriculum,  this.myForm.value.level)
  if(this.server_subscription_grouping_id!=0){
    this.submitUpdate(dd)

  }else{
    this.submitInsert(dd)
  }

}
submitInsert(dd:string){
  this.adminService.newSubscriptionGrouping(dd).subscribe(
    val=>{
      this.isSaving=false
      if(val['server_subscription_grouping_id']==0){
        this.errorSaving=true
      }
      else{
        this.nextRoute()
      }

    }
  )
}
submitUpdate(dd:string){
  this.adminService.updateSubscriptionGrouping(dd,this.server_subscription_grouping_id).subscribe(
    val=>{
      this.isSaving=false
      if(val['server_subscription_grouping_id']==0){
        this.errorSaving=true
      }
      else{
        this.nextRoute()
      }

    }
  )
}
nextRoute(){
  this.router.navigate([this.breakSavePath,this.server_subscription_group_id])
}
formatData(name:string,description:string,countryId:string, curriculumId:string,server_level_id:number){
  let data = new URLSearchParams();
  data.set('id',this.server_subscription_group_id.toString())
  data.set('description', description);
  data.set('server_country_id',countryId)
  data.set('server_curriculum_id',countryId)
  data.set('server_level_id',server_level_id.toString())
  data.set('name', name);
  data.set('subject_id', this.subjectId.toString());

  return data.toString()
}

loadLevels(value: number) {
  this.levelService.getLevelIdAndNameByCurriculum(value).subscribe(
    {next:(data:ResultData)=>{
      this.levels = data.rs.data
     },error:(err)=>{
      console.error("Error Retrieving Level and name By Country", err)
     }

        }
      )
    }

onLevelOptionsSelected(value: number) {
  this.subjectService.getSubjectsIdAndNameByLevel(value).subscribe(
    {next:(data:ResultData)=>{
      this.subjects = data.rs.data
    },error:(err)=>{
      console.error("Error retrieving subject by level",err)
    }
    }
  )
}
}

